import React from 'react';
import { Outlet } from 'react-router-dom';
import PositionDetail from './PositionDetail';

const PositionDetailLayout = () => {
  return (
    <>
      {/* PositionDetail reste toujours monté */}
      <PositionDetail />

      {/* Outlet pour les routes enfants (IndividualDetailPage) qui s'affichent par-dessus */}
      <Outlet />
    </>
  );
};

export default PositionDetailLayout;
